import { render, staticRenderFns } from "./SettingsTemplate.vue?vue&type=template&id=5815cb46&scoped=true&"
import script from "./SettingsTemplate.vue?vue&type=script&lang=js&"
export * from "./SettingsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTemplate.vue?vue&type=style&index=0&id=5815cb46&prod&lang=sass&scoped=true&"
import style1 from "./SettingsTemplate.vue?vue&type=style&index=1&id=5815cb46&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5815cb46",
  null
  
)

export default component.exports